/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'jsm.attachment-field.attachment-permission-error': 'Peça ao administrador que conceda a você a permissão para anexar arquivos.',
  'jsm.attachment-field.browse-with-dropzone': 'Para anexar, solte ou <a>procure</a> os arquivos',
  'jsm.attachment-field.create.uploadError': 'Erro ao fazer upload do anexo',
  'jsm.attachment-field.create.uploadErrorDescription': 'Ocorreu um erro ao fazer upload de um anexo',
  'jsm.attachment-field.create.uploadErrorForSizeLimit': 'Um formulário nunca pode ter mais de 50 anexos.',
  'jsm.attachment-field.default-render-error': 'Não é possível mostrar anexos nesse campo. Atualize esta página para tentar de novo.',
  'jsm.attachment-field.missing-token': 'Algo deu errado',
  'jsm.attachment-field.preview-field.attachment-upload': 'Os anexos vão ser enviados aqui',
  'jsm.attachment-field.services.delete-failed-description': 'Ocorreu um problema de conexão, e o anexo não foi excluído. Verifique a conexão de rede.',
  'jsm.attachment-field.services.delete-failed-title': 'Não foi possível excluir o anexo',
  'jsm.attachment-field.services.download-failed-description': 'Não foi possível terminar de fazer download dos anexos de {issueKey}. Verifique a conexão e tente de novo.',
  'jsm.attachment-field.services.download-failed-exceed-file-size-description': 'O tamanho total dos anexos de {issueKey} é grande demais para fazer download. Tente fazer download de cada anexo em separado.',
  'jsm.attachment-field.services.download-failed-title': 'Não foi possível fazer download dos anexos',
  'jsm.attachment-field.services.download-start-description': 'Isso pode demorar um pouco. Quando estiver tudo pronto, os anexos vão ficar em um arquivo zip no dispositivo.',
  'jsm.attachment-field.services.download-start-title': 'Fazendo download de anexos',
  'jsm.attachment-field.services.got-it': 'Entendi',
  'jsm.attachment-field.services.try-again': 'Tentar de novo',
  'jsm.attachment-field.shared-viewer.emptyState': 'Nenhum anexo transferido por upload'
};